export default {
    job: 'Job',
    searcJob: 'Search Job',
    search: 'Search',
    jobName: 'Job Name',
    jobAddress: 'Job Address',
    contactPerson: 'Contact Person',
    action: 'Action',
    createJob: 'Create Job',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    deleteJob: 'Delete Job',
    wantToDelete: 'Are you sure you want to delete',
    jobIsDeleted: 'Job is deleted'
}
